<template>
  <v-navigation-drawer
    id="org-select"
    app
    mini-variant-width="74"
    width="260"
    expand-on-hover
    v-bind="$attrs"
    color="accent"
    style="z-index:7"
  >
    <org-list />
  </v-navigation-drawer>
</template>

<script>
  import OrgList from './OrgList.vue'

  export default {
    name: 'MultiOrgDrawer',
    components: { OrgList },
  }
</script>
